
export default class RouteNames {
    // Click And Buy
    public static cbConvocationList = 'cb-convocationList';
    public static cbPariticipantList = 'cb-participantList';
    public static cbPurchaseParticipant = 'purchaseParticipant';
    public static cbPurchase = 'purchase';
    public static cbPurchaseCompanion = 'purchaseCompanion';
    public static cbProductCategory = 'productCategory';
    public static cbSales = 'sales';

    // Manager
    public static ProductList = 'productList';
    public static EmployeeList = 'employeeList';
    public static ClientList = 'clientList';
    public static ClientEdit = 'clientEdit';
    public static ConvocationList = 'convocationList';
    public static ConvocationDetail = 'convocationDetail';
    public static SyncDetail = 'syncDetail';
    public static Settings = 'settings';
    public static PurchaseConvocationList = 'purchaseConvocationList';
    public static PurchaseConvocationDetail = 'purchaseConvocationDetail';
    public static BudgetList = 'budgetList';
    public static BudgetName = 'budgetName';
    public static BillList = 'billList';
    public static BillEdit = 'billEdit';
    public static BudgetEdit = 'budgetEdit';

    // Client
    public static BudgetAcceptance = 'budgetAcceptance';
    public static BudgetAcceptanceValidation = 'budgetAcceptanceValidation';
    public static BudgetMandateSignature = 'budgetMandateSignature';

    // DNI Login
    public static BudgetLoginDni = 'BudgetLoginDni';
}
